<template>
  <div class="classStudy" id="print">
    <el-card class="box-card">
      <div class="paperManger">
        <el-button
          v-auth="'paperManger_/examinationCredentials/batchPrint'"
          :disabled="multipleSelection.length <= 0"
          @click="batchPrint"
          >批量打印<span v-if="multipleSelection.length > 0"
            >({{ multipleSelection.length }})</span
          ></el-button
        >
        <el-button
          type="primary"
          @click.stop="addAgentRoleInfo"
          v-auth="'paperManger_/paperPrint'"
          >证书模板</el-button
        >
        <div
          class="classStudy-header row"
          v-auth="'paperManger_/examinationSetting/credentials'"
        >
          <el-cascader
            clearable
            style="width: 100%"
            v-model="searchForm.courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属课程"
            :options="subjectTreeList"
            @change="subjectChange(searchForm.courseIds)"
          ></el-cascader>
          <el-select
            style="width: 100%; margin-left: 10px"
            clearable
            v-model="searchForm.examSettingId"
            placeholder="请选择考试期数"
            @change="sequenceChange()"
          >
            <el-option
              v-for="item in examSettingList"
              :key="item.id"
              :label="'第' + item.sequence + '期'"
              :value="item.sequence"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div
        class="classStudy-table"
        v-auth="'paperManger_/examinationSetting/credentials'"
      >
        <el-table
          ref="multipleTable"
          :data="studyDataList"
          style="width: 100%"
          row-key="id"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            min-width="40"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            show-overflow-tooltip
            label="考试项目"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="sequence"
            label="考试期数"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.sequence }}期</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="answer"
            label="通过人数"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                @click.stop="goPerson(scope)"
                style="
                  color: rgb(64, 158, 255);
                  width: 100px;
                  display: inline-block;
                  text-align: center;
                "
                >{{ scope.row.count }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="collectionBeginTime"
            label="领取时间"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                >{{ scope.row.collectionBeginTime }} 至
                {{ scope.row.collectionEndTime }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="printType"
            label="状态"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.printType == '1'">领取中</span>
              <span v-if="scope.row.printType == '2'">领取结束</span>
              <span v-if="scope.row.printType == '3'">已结束</span>
              <span v-if="scope.row.printType == '4'">待领取</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                type="text"
                @click.stop="editPaper(scope.row)"
                v-auth="'paperManger_/examinationSetting/editCredentials'"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next, jumper, total, sizes"
          style="margin-top: 20px; text-align: left"
          :total="studyList.total"
          :page-size="studyList.pageSize"
          :page-sizes="[10, 20, 30, 40]"
          :current-page="studyList.pageNumber"
          @size-change="studySizeChange"
          @current-change="studyCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog title="添加部门" :visible.sync="addFormVisible" width="30%" left>
        <!-- <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"> -->
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth">
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label="模拟试卷" prop="sort">
                <el-input
                  type="number"
                  v-model="addForm.sort"
                  placeholder="请输入显示排序"
                  auto-complete="off"
                  maxlength="10"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label="考试时长" prop="resource">
                <el-input
                  v-model="addForm.phone"
                  placeholder="请输入部门电话"
                  auto-complete="off"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-form-item label="定时开启" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="addForm.remark"
                  placeholder="请输入备注"
                  auto-complete="off"
                  maxlength="255"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click.stop="reset()">重 置</el-button>
          <el-button type="primary" @click.stop="submitInfo">提 交</el-button>
        </div>
      </el-dialog>

      <el-dialog
        title="编辑领取信息"
        :visible.sync="addFormVisiblePaper"
        width="35%"
        left
      >
        <!-- <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"> -->
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth">
          <el-row>
            <!-- <p领取备注(在考生查看成绩处显示)p> -->
            <el-col>
              <div class="block">
                <p>领取时间</p>
                <el-date-picker
                  v-model="editedData.collectionTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  align="left"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  @ok="confirmCollectTime"
                ></el-date-picker>
              </div>
              <p>
                <span>领取备注</span>
                <span style="color: #ccc">（在考生查看成绩处显示）</span>
              </p>
              <el-input
                type="textarea"
                :rows="3"
                v-model="editedData.collectionRemark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: right">
          <el-button @click.stop="cancel()">取消</el-button>
          <el-button type="primary" @click.stop="submitPaper">提 交</el-button>
        </div>
      </el-dialog>
    </el-card>
    <Print ref="printDialog" :printData="printObjArr"></Print>
  </div>
</template>
<script>
import Print from "./components/print";
export default {
  components: {
    Print,
  },
  data() {
    return {
      searchForm: {
        courseIds: "",
        examSettingId: "",
      },
      timeList: [],
      examSettingList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      value3: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      startTime: "",
      endTime: "",
      allTime: "",
      courseTestIds: "",
      studyList: [],
      studyDataList: [],
      studySearch: {
        pageNumber: 1,
        pageSize: 10,
      },
      formLabelWidth: "80px",
      subjectTreeList: [],
      subjectTreeListTime: [],
      courseIds: [],
      addForm: {},
      addFormVisible: false,
      addFormVisiblePaper: false,
      paperList: {
        subjectId: 0,
        sequence: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      timeValueFir: "",
      timeValueSec: "",
      projectListValue: "",
      projectList: [],
      timeListValue: "",
      timeList: [],
      dataList: [],
      multipleSelection: [],
      printModal: false,
      printObjArr: [],
      editedData: {
        id: "",
        collectionRemark: "",
        collectionTime: "",
      }, // 编辑信息
    };
  },
  computed: {},
  mounted() {
    this.getSubjectCourseExamCount("init");
    // this.getSubjectTreeListTestTime()
  },
  methods: {
    getSubjectCourseExamCount(type) {
      this.api.examSetting
        .getSubjectCourseExamCount()
        .then((result) => {
          if (result.success) {
            this.subjectTreeList = result.data;
            this.searchForm.courseIds = result.data[0].children[0].children[0].id;
            if (type) {
              this.setInitFirstSelectOps(type);
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setInitFirstSelectOps(type) {
      this.api.examSetting
        .getExamSequenceList({ subjectId: this.subjectTreeList[0].children[0].id })
        .then((result) => {
          if (result.success) {
            this.examSettingList = result.data;
            this.searchForm.examSettingId = this.examSettingList[0]
              ? this.examSettingList[0].sequence
              : "";
            this.paperList.sequence = this.searchForm.examSettingId;
            this.paperList.courseId =
              typeof this.searchForm.courseIds == "string"
                ? this.searchForm.courseIds
                : this.searchForm.courseIds[2];
            this.paperList.subjectId =
              typeof this.searchForm.courseIds == "string"
                ? this.subjectTreeList[0].children[0].id
                : this.searchForm.courseIds[1];
            this.getSubjectTreeListM(this.paperList);
          } else {
            this.$message.error(result.message);
          }
        });
    },
    subjectChange(item) {
      if (typeof item == "object") {
        if (this.activeName == "first") {
          this.searchForm.courseIds = item[2];
          this.searchForm.examSettingId = "";
          this.getExamSettingList(item[1]);
        } else {
          this.getExamSettingList(item[1]);
          this.searchForm.examSettingId = "";
        }
      }
    },
    sequenceChange() {
      this.paperList.sequence = this.searchForm.examSettingId;
      this.paperList.courseId =
        typeof this.searchForm.courseIds == "string"
          ? this.searchForm.courseIds
          : this.searchForm.courseIds[2];
      this.paperList.subjectId =
        typeof this.searchForm.courseIds == "string"
          ? this.subjectTreeList[0].children[0].id
          : this.searchForm.courseIds[1];
      this.getSubjectTreeListM(this.paperList);
    },
    getExamSettingList(subjectId) {
      var params = { subjectId: subjectId };
      this.api.examSetting
        .getExamSequenceList(params)
        .then((result) => {
          if (result.success) {
            this.examSettingList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    batchPrint() {
      this.api
        .batchDownloadCertTemp({ examinationSettingId: this.multipleSelection.join(",") })
        .then((res) => {
          console.log(res.data);
          if (res.success) {
            this.printObjArr = res.data;
            console.log("this.printObjArr", this.printObjArr.length, this.printObjArr);
            this.printObjArr.length > 0
              ? this.$refs.printDialog.show(this.printObjArr)
              : "";
          }
        });
    },
    //获取列表
    getSubjectTreeListM(data) {
      this.api
        .getSubjectCourseTreeListPaper(data)
        .then((result) => {
          if (result.data.length === 0) {
            this.loading = false;
          } else {
            this.loading = false;
            this.studyList = result.data;
            this.studyDataList = result.data.records;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取项目和期数
    getSubjectTreeListTestTime() {
      this.api
        .getSubjectCourseTreeListTestTime()
        .then((result) => {
          this.projectList = result.data;
          console.log(result.data);
          var arr = [];
          this.projectList.forEach(function (value, index, array) {
            console.log(value.sequences);
            value.sequences.forEach(function (val, index, array) {
              console.log(val);
              arr.push({ name: val + "期" });
              console.log(arr);
            });
          });
          this.timeList = arr;
          console.log(this.timeList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取列表
    projectListValueStatus(item) {
      console.log(this.projectListValue);
    },
    studySizeChange(pageSize) {
      this.studySearch.pageSize = pageSize;
    },
    studyCurrentChange(pageNumber) {
      this.studySearch.pageNumber = pageNumber;
    },
    addAgentRoleInfo() {
      this.$router.push({ path: "/paperPrint" });
    },
    editPaper(data) {
      console.log(data);
      this.addFormVisiblePaper = true;
      this.editedData = {
        id: data.id,
        collectionRemark: data.collectionRemark,
        collectionTime: [data.collectionBeginTime, data.collectionEndTime],
      };
      this.$set(this.editedData, "collectionTime", this.editedData.collectionTime);
    },
    confirmCollectTime(val) {
      console.log(val);
    },
    goPerson(value) {
      console.log(value);
      this.$router.push({ path: "/paperCollectionDetail", query: { id: value.row.id } });
    },
    cancel() {
      this.addFormVisiblePaper = false;
    },
    submitPaper() {
      let params = {
        id: this.editedData.id,
        collectionRemark: this.editedData.collectionRemark,
        collectionBeginTime: this.editedData.collectionTime[0]
          ? this.editedData.collectionTime[0]
          : "",
        collectionEndTime: this.editedData.collectionTime[1]
          ? this.editedData.collectionTime[1]
          : "",
      };
      this.api
        .getSubjectCourseTreeListEditPaper(params)
        .then((result) => {
          this.addFormVisiblePaper = false;
          this.getSubjectTreeListM(this.paperList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSelectionChange(val) {
      this.dataList = val;
      var arr = [];
      var NoticeArr = [];
      this.dataList.forEach(function (value, index, array) {
        arr.push(value.id);
        NoticeArr.push({ mobiles: value.mobile });
      });
      this.multipleSelection = arr;
      console.log(val, this.multipleSelection);
    },
  },
  watch: {
    "editedData.collectionTime": function (newVal) {
      console.log(newVal);
    },
    projectListValue(value) {
      this.projectListValue = value;
      console.log(value);
    },

    timeListValue(value) {
      this.timeListValue = value;
      console.log(value);
    },
  },
};
</script>
<style scoped>
.classStudy-button {
  float: right;
}
.classStudy-table {
  margin-top: 20px;
}
.paperManger {
  display: flex;
}
.classStudy-header {
  position: absolute;
  right: 100px;
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/examMode.vue